
import { Button } from "reactstrap";
import { useDeleteUsedBy } from "./api/deleteUsedBy";


const DeleteUsedBy = ({handleCloseModal, usedById}: DeleteUsedByProps)  => {
  
  const deleteUsedByMutation = useDeleteUsedBy({ usedById });
  const handleSubmit = async (): Promise<void> => {
    deleteUsedByMutation.mutateAsync({ 
      usedById: usedById
    })

    handleCloseModal();
  }

  return (
    <>
        <label>Είστε σίγουροι οτι θέλετε να διαγράψετε την παράμετρο 'Χρήση από'.;</label>
        <div>
          <Button style={{ margin: "10px" }} onClick={handleCloseModal}>Ακύρωση</Button>
          <Button style={{ margin: "10px" }} color='danger' onClick={handleSubmit}>Διαγραφή</Button>
        </div>
    </>
  )
}

interface DeleteUsedByProps{
  usedById: number;
  handleCloseModal: () => void;
}

export default DeleteUsedBy;